import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Form, Button, Card, Alert, Container } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import { useAuth } from "../context/AuthContext";

const LoginTrabajador = () => {
  const [telefono, setTelefono] = useState("");
  const [codigo, setCodigo] = useState("");
  const [step, setStep] = useState(1); // 1: pedir teléfono, 2: pedir código
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [webhook, setWebhook] = useState(null);
  const hasAutoSubmitted = useRef(false);
  const { setUser } = useAuth();

  useEffect(() => {
    const telefonoParam = searchParams.get("telefono");
    if (telefonoParam && !hasAutoSubmitted.current) {
      setTelefono(telefonoParam);
      handleSubmitTelefono(undefined, telefonoParam);
      hasAutoSubmitted.current = true;
    }
    // eslint-disable-next-line
  }, []);

  const handleChangeTelefono = (e) => {
    setTelefono(e.target.value);
  };

  const handleChangeCodigo = (e) => {
    setCodigo(e.target.value);
  };

  // Paso 1: Enviar teléfono
  const handleSubmitTelefono = async (e, telefonoParam) => {
    if (e) e.preventDefault();
    setLoading(true);
    setError("");
    const phoneToUse = telefonoParam || telefono;
    try {
      // 1. Ejecutar el procedure para obtener el webhook
      const procRes = await axios.post("/api/auth/exec-procedure", {
        procedure: "Q2B_DEFAULTS_GET_WEBHOOKS",
      });
      const webhookUrl = procRes.data?.WEBHOOK_LOGIN_GASTOS;
      if (!webhookUrl)
        throw new Error("No se pudo obtener el webhook de login");
      setWebhook(webhookUrl);

      // 2. Llamada POST al webhook
      const resp = await axios.post(webhookUrl, { phone: phoneToUse });
      if (resp.data.success) {
        toast.success("Código enviado por Whatsapp");
        setStep(2); // Pasar a pedir código
      } else {
        setError(resp.data.message || "Error al enviar código");
        toast.error(resp.data.message || "Error al enviar código");
      }
    } catch (err) {
      setError(
        err.response?.data?.message || err.message || "Error al enviar código"
      );
      toast.error(
        err.response?.data?.message || err.message || "Error al enviar código"
      );
    } finally {
      setLoading(false);
    }
  };

  // Paso 2: Validar código
  const handleSubmitCodigo = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const resp = await axios.post("/api/auth/validar-login-trabajador", {
        telefono,
        codigo,
      });
      if (resp.data.token && resp.data.user) {
        localStorage.setItem("token", resp.data.token);
        localStorage.setItem("user", JSON.stringify(resp.data.user));
        setUser(resp.data.user);
        toast.success("¡Inicio de sesión exitoso!");
        navigate("/gastos");
      } else if (resp.data.error) {
        setError(resp.data.error);
        toast.error(resp.data.error);
      } else {
        setError("Error desconocido");
        toast.error("Error desconocido");
      }
    } catch (err) {
      setError(
        err.response?.data?.error || err.message || "Error al validar código"
      );
      toast.error(
        err.response?.data?.error || err.message || "Error al validar código"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Container>
        <Card className="login-card">
          <Card.Body>
            <Card.Title className="text-center mb-4">
              <h3>App Gastos</h3>
              <p className="text-muted">Login Trabajador</p>
            </Card.Title>

            {error && (
              <Alert variant="danger" dismissible onClose={() => setError("")}>
                {error}
              </Alert>
            )}

            {step === 1 && (
              <Form onSubmit={handleSubmitTelefono}>
                <Form.Group className="mb-3">
                  <Form.Label>Teléfono</Form.Label>
                  <Form.Control
                    type="text"
                    name="telefono"
                    value={telefono}
                    onChange={handleChangeTelefono}
                    placeholder="Ingresa tu teléfono"
                    required
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100"
                  disabled={loading}
                >
                  {loading ? "Enviando código..." : "Enviar Código"}
                </Button>
              </Form>
            )}

            {step === 2 && (
              <Form onSubmit={handleSubmitCodigo}>
                <Form.Group className="mb-3">
                  <Form.Label>Código recibido por Whatsapp</Form.Label>
                  <Form.Control
                    type="text"
                    name="codigo"
                    value={codigo}
                    onChange={handleChangeCodigo}
                    placeholder="Ingresa el código"
                    required
                  />
                </Form.Group>

                <Button
                  variant="primary"
                  type="submit"
                  className="w-100"
                  disabled={loading}
                >
                  {loading ? "Validando..." : "Validar Código"}
                </Button>
              </Form>
            )}
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default LoginTrabajador;
